// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2140":"1369bf19de92346f","3367":"b4f2933c9f471fb9","7393":"883a33245ea7f3f9"}[chunkId] + ".js";
};